import {
  resolveLineMaterial,
  resolveLineMaterialNo,
} from '#/modules/imsMgmt/receipts/stocktake/helper/resolveLineMaterial';

/**
 * detail.lines[] → Create／Edit 掃描列 shape。
 * 維持後端陣列序；Edit 頁再以庫編 sort 後操作。
 * 系統量：後端 create／update 快照 → 讀 `systemQty`（舊別名 `baseQty` 過渡）；缺值 null（顯示 —）。
 * create／update body **不送**系統量（見 serialize）。
 * 契約不接受無帳列；查無庫存＝404。物料：`material`／`materialNo`（`mtr`／`mtrNo` 舊別名）。
 */
export function mapStocktakeDetailLineToScanLine(line = {}) {
  const inventoryStock = line.inventoryStock ?? null;
  const invStockId = inventoryStock?.id ?? line.inventoryStockId ?? null;
  const countedWarehouse = line.countedWarehouse ?? null;
  const mtr = resolveLineMaterial(line);
  const countedQty = line.countedQty ?? line.countedQuantity ?? 0;
  const systemQtyRaw = line.systemQty ?? line.baseQty;
  const systemQty = systemQtyRaw == null || systemQtyRaw === ''
    ? null
    : systemQtyRaw;

  return {
    invStockId,
    inventoryStockId: invStockId,
    stockNo: line.stockNo ?? inventoryStock?.stockNo ?? '',
    mtrId: mtr?.id ?? '',
    mtrNo: resolveLineMaterialNo(mtr),
    mtrName: mtr?.name ?? '',
    warehouseId: countedWarehouse?.id ?? '',
    warehouseLabel: countedWarehouse?.name
      || countedWarehouse?.code
      || '',
    locationLabel: '',
    systemQty,
    countedQty,
    countedAt: line.countedAt ?? null,
    unitLabel: line.unit?.name || line.unit?.code || '',
  };
}

export function mapStocktakeDetailToFormState(detail) {
  const lines = (detail?.lines ?? []).map(mapStocktakeDetailLineToScanLine);
  return {
    remark: detail?.remark ?? '',
    updatedAt: detail?.record?.updatedAt ?? detail?.updatedAt ?? null,
    lines,
  };
}
